// extracted by mini-css-extract-plugin
export default {"wrapper":"noItem_wrapper__pocxc","iconWrapper":"noItem_iconWrapper__Kf+C8","title":"noItem_title__hrc1e","desc":"noItem_desc__I+psJ"};